// apps/web/src/api/customerOps.ts
import apiClient from '../lib/axios';

export type OrderStatus = 'PENDING' | 'IN_PROGRESS' | 'READY_FOR_PICKUP' | 'COMPLETED' | 'CANCELLED';
export type FulfillmentType = 'PICKUP' | 'DELIVERY';
export type StuckTier = 'WARNING' | 'CRITICAL';

export interface StuckOrder {
  id: string;
  trackingUUID: string;
  customerName: string;
  pharmacyChainName: string;
  status: OrderStatus;
  fulfillmentType: FulfillmentType;
  createdAt: string;
  ageHours: number;
  tier: StuckTier;
}

export interface OpsSummary {
  stuckOrders: StuckOrder[];
  stuckWarningCount: number;
  stuckCriticalCount: number;
  ordersToday: number;
  ordersLast24h: number;
}

export interface CustomerFunnel {
  newSignups7d: number;
  newSignups30d: number;
  totalCustomers: number;
  activatedCustomers: number;
  activationRate: number;
  intentGapCount: number;
  intentGapRate: number;
  searches30d: number;
  orders30d: number;
  searchToOrderRatio: number;
}

export interface LiveOrder {
  id: string;
  trackingUUID: string;
  customerName: string;
  pharmacyChainName: string;
  status: OrderStatus;
  fulfillmentType: FulfillmentType;
  itemCount: number;
  totalAmount: string;
  ageMinutes: number;
  createdAt: string;
}

export interface LiveOrderFeed {
  items: LiveOrder[];
  total: number;
}

export interface LiveOrdersQuery {
  status?: OrderStatus;
  search?: string;
  limit?: number;
}

export async function getOpsSummary(): Promise<OpsSummary> {
  const { data } = await apiClient.get<OpsSummary>('/admin/customer-ops/ops');
  return data;
}

export async function getCustomerFunnel(): Promise<CustomerFunnel> {
  const { data } = await apiClient.get<CustomerFunnel>('/admin/customer-ops/funnel');
  return data;
}

export async function getLiveOrders(query: LiveOrdersQuery = {}): Promise<LiveOrderFeed> {
  const params = new URLSearchParams();
  if (query.status) params.append('status', query.status);
  if (query.search) params.append('search', query.search);
  if (query.limit) params.append('limit', String(query.limit));
  const qs = params.toString();
  const { data } = await apiClient.get<LiveOrderFeed>(
    `/admin/customer-ops/live-orders${qs ? `?${qs}` : ''}`,
  );
  return data;
}
